import constants from "../../../constants";
import h from "../../h";
import hanhChinhUtils from "../../hanhChinhUtils";
import utils from "../../utils";

const hcCommandBaoCaoChangeLogsBuilder = {
  newInstance() {
    return {
      //data;
      dataJson: null,
      oldHcCongViecTrongTam: null,
      newHcCongViecTrongTam: null,
      oldHcCongViecTrongTamUsers: null,
      newHcCongViecTrongTamUsers: null,
      newPhuTrachActors: null,
      oldPhuTrachActors: null,
      valueChangeLogs: [],
      hcDocRelations: null,
      oldHcDocRelations: null,
      actionLog: null,

      //
      build(dataJson) {
        return new Promise(resolve => {
          this.dataJson = dataJson;
          this.populateValueChangeLogs();
          resolve({ valueChangeLogs: this.valueChangeLogs });
        });
      },

      getDisplayProperty(property) {
        switch (property) {
          case "phuTrachCap1Id":
            return "Lãnh đạo đ/v phụ trách";
          case "phuTrachCap2Id":
            return "Chuyên viên đ/v phụ trách";
          case "commandsStatus":
            return "Tiến độ xử lý";
          case "completeDate":
            return "Ngày hoàn thành";
          case "progressImplement":
            return "Báo cáo kết quả thực hiện";
          case "lateReason":
            return "Lý do chậm tiến độ";
          case "hcDocRelations":
            return "Văn bản liên quan";
          default:
            return "-";
        }
      },

      populateValueChangeLogs() {
        this.oldHcCongViecTrongTam = this.dataJson.oldHcCongViecTrongTam;
        this.newHcCongViecTrongTam = this.dataJson.newHcCongViecTrongTam;
        this.oldHcCongViecTrongTamUsers = this.dataJson.oldHcCongViecTrongTamUsers;
        this.newHcCongViecTrongTamUsers = this.dataJson.newHcCongViecTrongTamUsers;
        this.newPhuTrachActors = this.dataJson.newPhuTrachActors;
        this.oldPhuTrachActors = this.dataJson.oldPhuTrachActors;
        this.hcDocRelations = this.dataJson.hcDocRelations || [];
        this.oldHcDocRelations = this.dataJson.oldHcDocRelations || [];

        h.each(
          [
            "phuTrachCap1Id",
            "phuTrachCap2Id",
            "commandsStatus",
            "completeDate",
            "progressImplement",
            "lateReason",
            "hcDocRelations"
            // "docRelationForms",
          ],
          property => {
            let oldValue;
            let newValue;
            switch (property) {
              case "phuTrachCap1Id":
                this.populateValueChangeLogsForActor(
                  property,
                  constants.HC_CASE_COMMANDS_USER.TYPE.PHU_TRACH_CAP1
                );
                break;
              case "phuTrachCap2Id":
                this.populateValueChangeLogsForActor(
                  property,
                  constants.HC_CASE_COMMANDS_USER.TYPE.PHU_TRACH_CAP2
                );
                break;
              case "commandsStatus":
                oldValue = this.oldHcCongViecTrongTam[property];
                newValue = this.newHcCongViecTrongTam[property];
                if (oldValue !== newValue) {
                  return this.valueChangeLogs.push({
                    property: property,
                    propertyLabel: this.getDisplayProperty(property),
                    oldValue: hanhChinhUtils.getHcCommandStatusLabel(oldValue),
                    newValue: hanhChinhUtils.getHcCommandStatusLabel(newValue)
                  });
                }
                break;
              case "completeDate":
                oldValue = this.formatDate(this.oldHcCongViecTrongTam[property]);
                newValue = this.formatDate(this.newHcCongViecTrongTam[property]);
                if (oldValue !== newValue) {
                  return this.valueChangeLogs.push({
                    property: property,
                    propertyLabel: this.getDisplayProperty(property),
                    oldValue: oldValue,
                    newValue: newValue
                  });
                }
                break;
              case "hcDocRelations":
                this.populateValueChangeLogsForHcDocRelations(property);
                break;
              default:
                oldValue = this.oldHcCongViecTrongTam[property];
                newValue = this.newHcCongViecTrongTam[property];
                if (oldValue !== newValue) {
                  return this.valueChangeLogs.push({
                    property: property,
                    propertyLabel: this.getDisplayProperty(property),
                    oldValue: oldValue,
                    newValue: newValue
                  });
                }
            }
          }
        );
      },

      formatDate(value) {
        return hanhChinhUtils.formatDate(value);
      },

      populateValueChangeLogsForActor(property, type) {
        let oldActor = h.find(this.oldPhuTrachActors, actor =>
          h.exists(
            this.oldHcCongViecTrongTamUsers,
            hcCongViecTrongTamUser =>
              hcCongViecTrongTamUser.userId === actor.id &&
              hcCongViecTrongTamUser.type === type
          )
        );
        let newActor = h.find(this.newPhuTrachActors, actor =>
          h.exists(
            this.newHcCongViecTrongTamUsers,
            hcCongViecTrongTamUser =>
              hcCongViecTrongTamUser.userId === actor.id &&
              hcCongViecTrongTamUser.type === type
          )
        );
        let oldId = oldActor ? oldActor.id : null;
        let newId = newActor ? newActor.id : null;

        if (oldId !== newId) {
          this.valueChangeLogs.push({
            property: property,
            propertyLabel: this.getDisplayProperty(property),
            oldValue: utils.buildUserDeptRoleViewLabel(oldActor),
            newValue: utils.buildUserDeptRoleViewLabel(newActor)
          });
        }
      },

      populateValueChangeLogsForHcDocRelations(property) {
        hanhChinhUtils.populateValueChangeLogsForHcDocRelations(
          property,
          this.oldHcDocRelations,
          this.hcDocRelations,
          this.valueChangeLogs,
          this.getDisplayProperty(property)
        );
      }
    };
  }
};

export default hcCommandBaoCaoChangeLogsBuilder;



// WEBPACK FOOTER //
// ./src/services/hanhchinh/congviectrongtam/hcCVTTBaoCaoChangeLogsBuilder.js